<script setup></script>

<template>
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_6006_22650)">
      <path
        d="M14.3916 8.75537C9.83812 10.7484 7.76246 16.0554 9.75549 20.6089C11.7485 25.1624 17.0555 27.2381 21.609 25.245C26.1625 23.252 28.2382 17.945 26.2452 13.3915C25.3209 11.2798 23.6839 9.70107 21.74 8.81383"
        stroke-linecap="round"
      />
      <path d="M13.8867 12.2979L14.8531 8.41635L10.9716 7.44995" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <filter id="filter0_d_6006_22650" x="0" y="0" width="36" height="36" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6006_22650" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6006_22650" result="shape" />
      </filter>
    </defs>
  </svg>
</template>

<style scoped lang="scss"></style>
